import PropTypes from "prop-types";
import { connect } from "react-redux";
import dayjs from "@shared/dayjs";

import { Download, Trash } from "../../../../../shared/v2/Icomoon";
import IconButton from "../../../../../shared/v2/IconButton";
import { toggleDeleteModal } from "../../actions/creators";
import { DocumentPropType } from "../../propTypes";

const downloadDocument = (fileName, url) => {
  const anchor = document.createElement("a");
  anchor.setAttribute("download", fileName);
  anchor.setAttribute("href", url);
  anchor.setAttribute("target", "_blank");
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

const InlineContext = ({ document, dispatch = () => {} }) => {
  const handleDownload = (e) => {
    e.stopPropagation();
    downloadDocument(document.fileName, document.expiringUrl);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    dispatch(toggleDeleteModal([document.id], false));
  };

  return (
    <td>
      <div className="tw-flex tw-justify-end tw-items-center tw-gap-8px tw-mb-4px">
        <IconButton
          size="small"
          schema="tertiary"
          onClick={handleDownload}
          data-cy="document-list-item-download-button"
        >
          <Download />
        </IconButton>

        <IconButton
          size="small"
          schema="tertiary"
          onClick={handleDelete}
          data-cy="document-list-item-delete-button"
        >
          <Trash />
        </IconButton>
      </div>

      <p
        className="tw-m-0 tw-text-12d tw-font-normal tw-text-neutral-gray-50 tw-text-right"
        data-cy="document-list-item-date-created-at"
      >
        {dayjs(document.uploadedAt).format("MM/DD/YYYY")}
      </p>
    </td>
  );
};

InlineContext.propTypes = {
  document: DocumentPropType.isRequired,
  dispatch: PropTypes.func,
};

export default connect()(InlineContext);
